// extracted by mini-css-extract-plugin
export var container = "_fv-0";
export var icon = "_fv-1";
export var text = "_fv-2";